import { create } from 'zustand';

const useNotificationStore = create((set, get) => ({
  notifications: [],

  showNotification: (notification) => {
    const id = Date.now() + Math.random();
    const newNotification = {
      id,
      type: notification.type || 'info',
      title: notification.title,
      message: notification.message,
      duration: notification.duration !== undefined ? notification.duration : 5000,
    };

    set((state) => {
      // Prevent duplicate notifications with same ID
      const existingIndex = state.notifications.findIndex(n => n.id === id);
      if (existingIndex !== -1) {
        return state;
      }
      return {
        notifications: [...state.notifications, newNotification],
      };
    });

    return id;
  },

  removeNotification: (id) => {
    set((state) => {
      const filtered = state.notifications.filter((n) => n.id !== id);
      // Only update if something actually changed
      if (filtered.length === state.notifications.length) {
        return state;
      }
      return {
        notifications: filtered,
      };
    });
  },

  clearAll: () => {
    set((state) => {
      if (state.notifications.length === 0) {
        return state;
      }
      return { notifications: [] };
    });
  },
}));

// Global function for easy access
if (typeof window !== 'undefined') {
  window.showNotification = (notification) => {
    useNotificationStore.getState().showNotification(notification);
  };
}

export default useNotificationStore;

